module.exports = __webpack_public_path__ + "static/media/main-title-block__bg-vacancy.19fa41b7.png";